import PropTypes from 'prop-types'
import React from 'react'
import { bindActionCreators } from 'redux'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'

import { makeOptions } from 'helpers/components'
import Button from 'components/Button'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import Textarea from 'components/Form/Textarea'
import Modal from 'components/Modal'

import { packItem } from 'routes/Orders/modules/order'

import classes from './PackItem.scss'

export const fields = ['id', 'packed_qty', 'packed_uom_id', 'packed_notes']

class PackItemModal extends React.Component {
  onSubmit = (...args) => {
    const submitResponse = this.props.handleSubmit(...args)

    if (submitResponse) { // returns a promise, hopefully
      submitResponse.then(response => {
        typeof this.props.closeAction === 'function' && this.props.closeAction()
      })
    }
  };

  getUomOptions = (props = this.props) => {
    return makeOptions(props.uoms) // admins get all uoms
  };

  renderForm = () => {
    return <form onSubmit={this.onSubmit}>
      <fieldset className={classes.fieldset}>
        <Input label='Quantity' placeholder='quantity' pattern='[0-9]+(\.[0-9]{0,})?' {...this.props.fields.packed_qty} />
      
        <Select label='Unit of Measure'
          placeholder='select a unit'
          selectOptions={this.getUomOptions()}
          options={['expandable--tiny', 'expandable--small']}
          filterModelFields={['shorthand']}
          {...this.props.fields.packed_uom_id}
        />

        <Textarea label='Note' placeholder='Notes for the invoice' maxLength={50} {...this.props.fields.packed_notes} />

        <div className={classes.buttons}>
          <Button options={['green']} submit>Submit</Button>
          <Button options={['red']} callback={this.props.closeAction}>Cancel</Button>
        </div>
      </fieldset>
    </form>
  };

  render () {
    return <Modal
      contentLabel='Pack'
      isOpen={this.props.isOpen}
      onRequestClose={this.props.closeAction}
      title='Packing'
      description={<strong>
        Ordered: {this.props.order.qty} {this.props.order.uom.shorthand || this.props.order.uom.name}
        {' '}{this.props.order.product.name}

        {this.props.order.packed_by && this.props.order.packed_by.id && <span>
          <br />
          Packed by: {this.props.order.packed_by.email}
        </span>}
      </strong>}
    >
      {this.renderForm()}
    </Modal>
  }
}

PackItemModal.propTypes = {
  order: PropTypes.shape({
    // Lots more:
    id: PropTypes.number.isRequired,

    product: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,

    qty: PropTypes.number,
    uom: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      shorthand: PropTypes.string,
    }).isRequired,

    packed_by: PropTypes.shape({
      id: PropTypes.number,
      email: PropTypes.string,
    }),
  }).isRequired,

  uoms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    shorthand: PropTypes.string,
  })).isRequired,

  isOpen: PropTypes.bool,
  closeAction: PropTypes.func,
  successCallback: PropTypes.func,
  errorCallback: PropTypes.func,

  // From redux-form:
  fields: PropTypes.object.isRequired,
  values: PropTypes.shape({
    id: PropTypes.number.isRequired,
    packed_qty: PropTypes.string,
    packed_uom_id: PropTypes.number,
    packed_notes: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
}

PackItemModal.defaultProps = {
  isOpen: false
}

const mapActionCreators = {
  onSubmit: packItem
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    id: ownProps.order.id, // NOTE: We put this into the state…so we can send it into the submit, I guess.
    packed_qty: ownProps.order.packed_qty || ownProps.order.qty || '',
    packed_uom_id: ownProps.order.packed_uom_id || ownProps.order.uom_id || '',
    packed_notes: ownProps.order.packed_notes || '',
  },
  uoms: state.uoms,
})

export const form = reduxForm({
  form: 'packItem',
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.id) errors.id = 'Unable to pack, missing order…'
    if (!state.packed_qty) errors.packed_qty = 'Please enter a qty.'
    if (!state.packed_uom_id) errors.packed_uom_id = 'Please select a unit of measure.'
    if (state.packed_notes && state.packed_notes.length > 50) errors.packed_notes = 'Order Notes should be a maximum 50 characters.'

    return errors
  }
})(PackItemModal)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/containers/Modals/PackItem/PackItem.js